var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('home-sidebar',{staticClass:"home-page__sidebar"}),_c('v-content',{staticClass:"fill-height"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }